// trailing slash needed on POST requests
export const NexusRoutes = {
  AcceptInvitation: '/users/auth/accept_invite/',
  MultiFactorAuthentication: '/users/auth/multi_factor_authentication/',
  ResetPassword: '/users/auth/password/reset/',
  ResetPasswordConfirm: '/users/auth/password/reset/confirm/',
  SignIn: '/users/auth/login/',
  UpdatePassword: '/users/auth/password_change/',
  UpdateUserDetails: '/users/auth/user_details/',
};
